// import '../components/**/script.js';
// import '../filters/**/script.js';
import '../blocks/benefits/js/script.js';
import '../blocks/map/js/script.js';


// WEBPACK FOOTER //
// ./src/js/script.js